import React from "react";
import "./video.css";

class Video extends React.Component {
  render() {
    if (this.props.type === "Autoplay") {
      return (
        <div className="contentBlock video">
          <video autoPlay playsInline loop muted src={this.props.url} />
        </div>
      );
    }
    return (
      <div className="contentBlock video">
        <video controls src={this.props.url} />
      </div>
    );
  }
}
export default Video;
